export const QUALTRICS_URL = new URL('https://pricelineresearch.qualtrics.com/jfe/form/SV_3jXKJkoqkydiAjI');